import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationDataDefault(year?: string) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-inadimplencia-data-default', year],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_INADIMPLENCIA_EXPIRACAO, year || null),
  });
}

export { useConsolidationDataDefault };
